package fr.frux.core.network.di

import fr.frux.core.common.auth.SessionExpiryNotifier
import fr.frux.core.common.auth.TokenStorage
import fr.frux.core.common.di.AppScope
import fr.frux.core.network.createFruxHttpClient
import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.SingleIn
import io.ktor.client.HttpClient

/**
 * Metro DI module providing network-related dependencies.
 *
 * Provides:
 * - Configured HttpClient with auth, logging, JSON serialization
 */
@ContributesTo(AppScope::class)
interface NetworkModule {

    companion object {
        /**
         * Provides singleton HttpClient instance.
         */
        @dev.zacsweers.metro.Provides
        @SingleIn(AppScope::class)
        fun provideHttpClient(
            tokenStorage: TokenStorage,
            sessionExpiryNotifier: SessionExpiryNotifier,
        ): HttpClient = createFruxHttpClient(
            tokenStorage = tokenStorage,
            sessionExpiryNotifier = sessionExpiryNotifier,
        )
    }
}
